import React from 'react';
import CheckBoxAttribute from 'components/Fields/CheckBoxAttribute';
import TextAttribute from 'components/Fields/TextAttribute';
import InputContainer from 'components/InputContainer';
import PropTypes from 'prop-types';
import { LABEL_SUFFIX } from 'utils/constants';
import { ERROR_TEXT_CHECKED_FIELD_NO_TEXT } from 'langs/en/errors';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';

class ConsentChannel extends React.Component {
  validateAndChangeCheckbox = (keyPath, value) => {
    this.props.onCheckboxChange(keyPath, value);
    if (!this.props.formSubState.text.trim()) {
      if (value) {
        this.props.onFieldValidityChange([...this.props.keyPath, 'text'], false, ERROR_TEXT_CHECKED_FIELD_NO_TEXT);
      } else {
        this.props.onFieldValidityChange([...this.props.keyPath, 'text'], true);
      }
    }
  }

  validateAndChangeRequiredField = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);

    if (!value.trim()) {
      this.props.onFieldValidityChange(keyPath, false, ERROR_TEXT_CHECKED_FIELD_NO_TEXT);
    } else {
      this.props.onFieldValidityChange(keyPath, true);
    }
  }

  render() {
    const {
      channelName,
      formSubState,
      uiSubState,
      keyPath,
      onFieldUIStateChange,
    } = this.props;

    return (
      <div className="mt-3">
        <div className="d-flex flex-fill">
          <CheckBoxAttribute
            className="mt-1"
            keyPath={[...keyPath, 'include']}
            onCheckBoxChange={this.validateAndChangeCheckbox}
            value={formSubState.include}
            labelledBy={generateHTMLIdFromKeyPath([...keyPath, 'text']).concat(LABEL_SUFFIX)}
          />
          <div className="ml-2 flex-fill">
            <InputContainer
              boldLabel={false}
              label={`Include ${channelName} communication channel option`}
              keyPath={[...keyPath, 'text']}
              uiState={uiSubState.text}
            >
              <TextAttribute
                keyPath={[...keyPath, 'text']}
                value={formSubState.text}
                onFieldValueChange={this.validateAndChangeRequiredField}
                onFieldUIStateChange={onFieldUIStateChange}
                placeholder={`Please contact me via ${channelName}...`}
                include={formSubState.include}
              />
            </InputContainer>
          </div>
        </div>
      </div>
    );
  }
}

ConsentChannel.propTypes = {
  channelName: PropTypes.string.isRequired,
  keyPath: PropTypes.array.isRequired,
  formSubState: PropTypes.shape({
    include: PropTypes.bool,
    text: PropTypes.string,
  }).isRequired,
  uiSubState: PropTypes.object.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onFieldValidityChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
};

export default ConsentChannel;
